<template>
    <div class="container-fluid mt-4">
        <b-tabs content-class="mt-3">
            <b-tab title="Your profile" active>
                <b-card>
                    <form @submit.prevent="saveUser">
                        <b-form-group label-align-sm="right">
                            <p>{{ user.first_name }} {{ user.last_name }}</p>
                        </b-form-group>

                        <b-form-group label="First name" label-align-sm="left">
                            <b-form-input
                                    id="save-user-first-name"
                                    v-model="user.first_name" type="text"
                            />
                        </b-form-group>

                        <b-form-group label="Last name" label-align-sm="left">
                            <b-form-input
                                    id="save-user-last-name"
                                    v-model="user.last_name" type="text"
                            />
                        </b-form-group>

                        <b-form-group label="Email" label-align-sm="left">
                            <b-form-input
                                    id="save-user-email"
                                    v-model="user.email"
                                    type="email"
                            />
                        </b-form-group>

                        <b-form-group label="Mobile number" label-align-sm="left">
                            <b-form-input
                                    id="save-user-mobile"
                                    v-model="user.mobile_number"
                                    type="text"
                            />
                        </b-form-group>

                        <b-form-group label="Time Zone" label-align-sm="left">
                            <b-form-select
                                    v-model="user.time_zone"
                                    :options="timezones"
                            />
                        </b-form-group>

                        <b-form-group label="Password" label-align-sm="left">
                            <b-form-input
                                    id="save-user-password"
                                    v-model="user.password"
                                    type="password"
                                    placeholder="●●●●●●●●"
                            />
                        </b-form-group>

                        <b-form-group label="Retype Password" label-align-sm="left">
                            <b-form-input
                                    id="password-confirm"
                                    v-model="password_confirmation"
                                    type="password"
                            />
                        </b-form-group>

                        <div>
                            <b-btn id="save-user-submit" type="submit" variant="success">
                                Save
                            </b-btn>
                            <b-btn id="save-user-cancel" to="/">
                                Cancel
                            </b-btn>
                        </div>
                    </form>
                </b-card>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

    import { getAlertTimezones } from '../networking/alerts'
    import { admin_methods } from '../networking/account'
    import usersApi from '../user_apis'
    
    export default {
        name: 'settings',
        props: {
            userData: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                user: {},
                password_confirmation: null,
                timezones: []
            }
        },

        async created(){ 
            this.loadUser() 
            const { value: { data }} = await getAlertTimezones()
            this.timezones = data
        },

        methods: {
            async loadUser() {
                const user = await usersApi.getUser(this.userData.userId)
                this.user = user.data
            },
            async saveUser() {
                window.scroll({ top: 0, left: 0, behavior: 'smooth' })

                const generator = admin_methods.edit_user(this.user)
                const { value: { data, alert }} = await generator.next()

                this.userData.firstName = this.user.first_name
                this.userData.lastName = this.user.last_name
                this.userData.email = this.user.email

                this.$emit(
                    'showAlert', 
                    alert.message, 
                    alert.variant, 
                    alert.variant === 'success' ? 1800 : 5000
                )
            }
        }
    }
</script>

<style scoped>

    #save-user-cancel { display: none }

</style>
